import React from 'react';

import { Control, Controller } from 'react-hook-form';

import { Checkbox } from 'components/DesignSystem/Checkbox';
import classes from 'components/Settings/Components/RolesManagement/components/addRole.module.scss';
import { IRoleForm } from 'components/Settings/Components/RolesManagement/rolesManagment.utils.type';

interface Props {
    myKey: string;
    index: number;
    name: string;
    id: string;
    control: Control<IRoleForm>;
}

export const SingleChoice = ({ myKey, index, name, id, control }: Props) => {
    return (
        <label id={id} className={`${classes.container}  ${myKey === 'users' && classes.listUsers}`}>
            <Controller
                control={control}
                render={({ field }) => (
                    <Checkbox size={'3rem'} checked={field.value} {...field} label={name} labelPlacement={'end'} />
                )}
                name={`privilegeList.${index}.value`}
            />
        </label>
    );
};
